import styled from '@emotion/styled';
import { Magnetic } from "../../styles";
export const CarouselContainer = styled('div') `
	height: 100%;
	.carousel-root,
	.slider-wrapper,
	.slider {
		height: 100%;
		position: relative;
	}
	.carousel {
		bottom: 0;
		position: absolute;
	}
	@media only screen and (min-width: ${Magnetic.layoutBreakpointSm}) {
		.carousel ul li video {
			height: 100%;
		}
	}
	.carousel-slider {
		height: 78%;
		position: relative;
	}
	.slide {
		background-color: transparent;
	}
	.thumnail-container {
		margin: auto;
	}
	.left-arrow {
		left: -${Magnetic.spacer40};
	}
	.right-arrow {
		right: -${Magnetic.spacer40};
	}
	&:hover .left-arrow {
		left: ${Magnetic.spacer08};
	}
	&:hover .right-arrow {
		right: ${Magnetic.spacer08};
	}
	.control-prev.control-arrow,
	.control-next.control-arrow {
		height: 42px;
		top: 38%;
		opacity: 1;
		background-color: ${Magnetic.actionableColor};
		transition: all 0.3s ease-in-out;
		&:hover {
			background-color: ${Magnetic.actionableColorHover};
		}
		&:active {
			background-color: ${Magnetic.actionableColorActive};
		}
	}
	.control-next.control-arrow {
		border-radius: 10px 0 0 10px;
	}
	.control-prev.control-arrow {
		border-radius: 0 10px 10px 0;
	}
	.control-prev.control-arrow:before,
	.control-next.control-arrow:before {
		border: ${Magnetic.baseBorderStyle} ${Magnetic.colorNeutral5};
		padding: 4px;
		transform: rotate(-45deg);
	}
	.control-next.control-arrow:before {
		border-width: 0 5px 5px 0;
	}
	.control-prev.control-arrow:before {
		border-width: 5px 0 0 5px;
	}
	.thumb {
		height: 76px;
		border-color: transparent;
		vertical-align: bottom;
	}
	.thumb.selected {
		border-color: ${Magnetic.actionableColor};
	}
	&#${(props) => (props['data-custom-only-thumbnails'] ? props.id : '')} {
		.carousel {
			position: relative !important;
			margin-top: 120px !important;
		}
		.slide {
			height: ${Magnetic.spacer08};
			border-color: transparent;
			vertical-align: bottom;
		}
		.slide.selected {
			border-color: ${Magnetic.actionableColor};
		}
		.carousel.carousel-slider {
			display: none !important;
		}
		.carousel .thumb {
			width: 190px !important;
			height: 200px !important;
			position: relative;
			margin-right: 0px !important;
			padding: 0px !important;
			border: none;
		}
	}
`;
export const DocumentContainer = styled('div') `
	height: 100%;
	overflow-y: auto;
	overflow-x: hidden;
	position: relative;
`;
export const ImageContainer = styled('div') `
	flex-shrink: 0;
	max-height: 100%;
	width: 100%;
	height: 100%;
	position: absolute;
	top: 50%;
	left: 50%;
	margin-right: -50%;
	transform: translate(-50%, -50%);
`;
export const PopoutImageContainer = styled(ImageContainer) `
	user-select: none;

	&:focus {
		outline: none;
	}
`;
export const Image = styled('img') `
	max-height: 100%;
	max-width: 100%;
	object-fit: contain;
	position: relative;
	top: 50%;
	left: 0;
	transform: translateY(-50%);

	@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
		width: auto;
	}
`;
export const ThumbnailContainer = styled('div') `
	height: 100%;
	background-color: ${Magnetic.colorBlack};
	cursor: ${Magnetic.actionableCursor};
`;
export const ThumbnailImage = styled('img') `
	height: 100%;
	object-fit: cover;
`;
export const NavContainer = styled('div') `
	width: 40px;
	height: 40px;
	text-align: center;
	top: 50%;
	position: absolute;
	border-radius: 22px;
	font-size: ${Magnetic.fontSize18};
	background-color: ${Magnetic.actionableColor};
	transition: all 0.3s ease-in-out;
	transform: translateY(-50%);
	z-index: 1;
	cursor: ${Magnetic.actionableCursor};
	&:hover {
		background-color: ${Magnetic.actionableColorHover};
	}
	&:active {
		background-color: ${Magnetic.actionableColorActive};
	}
`;
export const NavButton = styled('span') `
	color: ${Magnetic.colorWhite};
	top: 22%;
	position: relative;
	right: 0;
`;
export const StyledCarouselItemButton = styled('button') `
	display: grid;
	text-align: center;
	cursor: pointer;
	border: none;
	outline: none;
	margin: ${Magnetic.spacer20} ${Magnetic.spacer32} ${Magnetic.spacer04} ${Magnetic.spacer32};
	background: none;
`;
export const StyledItemTitle = styled('h6') `
	text-align: center;
	margin: 0px;
	width: 100%;
	font-size: ${Magnetic.fontSize20}
	font-weight: ${Magnetic.fontWeightNormal};
	left: 0;
	white-space: pre-wrap;
`;
export const StyledThumbnailView = styled('div') `
	width: 100%;
	padding: ${Magnetic.spacer40} 0;
`;
export const StyledCustomImageContainer = styled('div') `
	max-height: 100%;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: ${(props) => props.width}px;
`;
export const StyledVideoContainer = styled('div') `
	width: 78%;
	height: 86%;
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 0 auto;
`;
//# sourceMappingURL=style.js.map